import { render, staticRenderFns } from "./TagEdit.vue?vue&type=template&id=219cb252&scoped=true&"
import script from "./TagEdit.vue?vue&type=script&lang=ts&"
export * from "./TagEdit.vue?vue&type=script&lang=ts&"
import style0 from "./TagEdit.vue?vue&type=style&index=0&id=219cb252&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219cb252",
  null
  
)

export default component.exports